/**
 * Chart-column geometry for the trade header.
 * The header spans the order panel and app sidebar, so chart controls
 * align to the measured right edge of `.chart-section` instead of the viewport.
 */

let chartSectionRight = null;

export function setChartSectionRight(right) {
  const next = Number.isFinite(right) ? right : null;
  if (next === chartSectionRight) return;
  chartSectionRight = next;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('chart-section-geometry'));
  }
}

export function getChartSectionRight() {
  return chartSectionRight;
}

export function clearChartSectionRight() {
  if (chartSectionRight == null) return;
  chartSectionRight = null;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('chart-section-geometry'));
  }
}

/**
 * CSS `right` offset (px) for the chart-count and layout controls.
 * Larger values sit further left. Keeps the group on the chart's right edge
 * without covering the header controls that sit over the order panel / sidebar.
 */
export function chartEdgeControlRight({
  navbarRight,
  chartRight,
  trailingLeft,
  controlsWidth,
  leftGroupRight,
  gap = 10,
  chartPadding = 8,
} = {}) {
  if (!Number.isFinite(navbarRight)) return null;
  const trailingBlock = Number.isFinite(trailingLeft)
    ? Math.max(0, navbarRight - trailingLeft + gap)
    : 0;
  if (!Number.isFinite(chartRight)) return Math.round(trailingBlock);

  let next = Math.max(navbarRight - chartRight + chartPadding, trailingBlock);
  if (Number.isFinite(leftGroupRight) && Number.isFinite(controlsWidth)) {
    const maxRight = navbarRight - leftGroupRight - controlsWidth - gap;
    next = Math.max(trailingBlock, Math.min(next, maxRight));
  }
  return Math.max(0, Math.round(next));
}
